<template>
    <div class="main">
        <!-- channel banner -->
        <div class="cbanner">
            <img src="../../../assets/images/banner_list.jpg" />
            <div class="btext">
                <h3>成功案例</h3>
                <p>最新金融快讯，全球投资信息，行业特色综合类新闻资讯</p>
            </div>
        </div>
        <div class="main_inner">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <span class="btitle">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>股权/资金投资</el-breadcrumb-item>
                <el-breadcrumb-item>成功案例</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row>
                <el-col :span="5" class="leftside">
                    <el-menu
                            default-active="3"
                            class="el-menu-vertical-demo"
                    >
                        <router-link :to="{ path: '/ecInvestmentIntroduction' }">
                            <el-menu-item index="1"><span slot="title" >股权/资金投资介绍</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/efInvestmentProject' }">
                            <el-menu-item index="2"><span slot="title">股权/资金投资项目</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/successfulCase' }">
                            <el-menu-item index="3"><span slot="title">成功案例</span></el-menu-item>
                        </router-link>
                    </el-menu>
                </el-col>
                <el-col :span="19">
                    <div class="con_right">
                        <div class="con">
                            <div class="news_detail">
                                <div class="content_news" v-html="this.content">

                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import  {reqSuccessfulCaseList} from "../../../api/contentManagement-api"
    export default {
        data(){
            return{
                content:'',
            }
        },
        methods:{
            getSuccessfulCase(){
                reqSuccessfulCaseList().then((res)=>{
                    if(res.data.code===1){
                        this.content=res.data.data[0].content;
                    }else{
                        this.content='<p>抱歉，暂无数据</p>'
                    }
                })
            }

        },
        mounted(){
            this.getSuccessfulCase();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/contentManagement/ecInvestment/successfulCase.vue